import React, { useState } from 'react';
import style from 'react/pages/live_classes/style.module.scss';
import cx from 'classnames';
import { LinkButton } from '@magoosh/lib/button';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { Collapse } from 'react-bootstrap';
import { LiveClass } from '../../../organisms/live_classes_list';
import { paths } from 'config/path_helpers';
import { useYourClassesContext } from '@magoosh/pages/live_classes/all_classes/context';

export const LiveClassesWidget: React.FC = () => {
  const { data, fetchData, setSubsection } = useYourClassesContext();
  const [expandedClasses, setExpandedClasses] = useState(true);

  React.useEffect(() => {
    fetchData('widget');
    setSubsection('widget');
  }, []);

  return (
    <div className={cx(style.upcomingClasses, 'u-padding-A-l u-margin-B-l')}>
      <div className={style.header}>
        <div>
          <h3 className="u-margin-T-xs u-margin-B-m">
            <strong>Upcoming Classes</strong>
          </h3>
          <p>Register to attend live or to watch later at your convenience.</p>
        </div>
        <LinkButton
          className={style.btnGrayLink}
          onClick={() => {
            setExpandedClasses(!expandedClasses);
          }}>
          {expandedClasses ? (
            <>
              Collapse <FontAwesomeIcon icon={'chevron-up'} />
            </>
          ) : (
            <>
              Expand <FontAwesomeIcon icon={'chevron-down'} />
            </>
          )}
        </LinkButton>
      </div>
      <div>
        <Collapse in={expandedClasses}>
          <div>
            {data.widget.upcoming.map((liveClass) => (
              <LiveClass key={liveClass.id} {...liveClass} hideDescription={true} />
            ))}
            <div>
              <a style={{ color: style.brandSecondary }} href={paths.liveClasses()}>
                <strong>View All Classes</strong>
              </a>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default LiveClassesWidget;
